import GameUI from "../components/GameUI.jsx";

const Game = () => {

  return (
    <div style={{ width: '100vw', height: '100vh' }}>
        <GameUI />
    </div>
  );
};

export default Game;
